export const CRM_CUSTOMIZATIONS_CONTEXT = 'crmCustomizations';
export const GROWTH_PLAN_NAV_TOOLTIP_CONTEXT = 'growthPlanNavTooltip';
export const USER_GUIDE_NAV_TOOLTIP_CONTEXT = 'userGuideNavTooltip';
export const IN_APP_SIDEPANEL_EXPOSURE_STORAGE_KEY = 'Growth:InAppSidePanel:ShowSidepanel';
export const IN_APP_SIDEPANEL_ORIGINATING_CUSTOMIZATION_TOUR_KEY = 'Growth:InAppSidePanel:OriginatingCrmCustomizationTour';